export enum PromotionType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}
